import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../api';

export default function IdeaCard({ idea, votedIdeas, onVote, onDelete }) {
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const hasVoted = votedIdeas.includes(idea.id);
  const isOwner = user?.id === idea.user_id;

  const handleVote = async () => {
    if (!user) return setError('Please log in to vote');
    if (isOwner) return setError("You can't vote on your own idea");
    setLoading(true);
    setError('');
    try {
      if (hasVoted) {
        await api.delete(`/votes/${idea.id}`);
      } else {
        await api.post(`/votes/${idea.id}`);
      }
      onVote();
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    if (!window.confirm('Delete this idea? Votes will be refunded.')) return;
    setLoading(true);
    try {
      await api.delete(`/ideas/${idea.id}`);
      onDelete();
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.card}>
      <div style={styles.voteSection}>
        <button
          onClick={handleVote}
          disabled={loading || isOwner}
          style={{
            ...styles.voteBtn,
            background: hasVoted ? '#2563eb' : '#f3f4f6',
            color: hasVoted ? '#ffffff' : '#374151',
          }}
        >
          ▲
        </button>
        <span style={styles.voteCount}>{idea.vote_count}</span>
      </div>

      <div style={styles.content}>
        <h3 style={styles.title}>{idea.title}</h3>
        {idea.description && (
          <p style={styles.description}>{idea.description}</p>
        )}
        <div style={styles.meta}>
          <span style={styles.author}>
            {idea.author_email.split('@')[0]}
          </span>
          <span style={styles.date}>
            {new Date(idea.created_at).toLocaleDateString()}
          </span>
          {isOwner && (
            <button
              onClick={handleDelete}
              disabled={loading}
              style={styles.deleteBtn}
            >
              Delete
            </button>
          )}
        </div>
        {error && <p style={styles.error}>{error}</p>}
      </div>
    </div>
  );
}

const styles = {
  card: {
    display: 'flex',
    gap: '16px',
    background: '#ffffff',
    border: '1px solid #e5e7eb',
    borderRadius: '10px',
    padding: '20px',
    marginBottom: '12px',
    transition: 'box-shadow 0.2s',
  },
  voteSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '4px',
    minWidth: '48px',
  },
  voteBtn: {
    width: '40px',
    height: '40px',
    borderRadius: '8px',
    border: '1px solid #e5e7eb',
    fontSize: '16px',
    cursor: 'pointer',
    fontWeight: '700',
    transition: 'all 0.15s',
  },
  voteCount: {
    fontSize: '18px',
    fontWeight: '700',
    color: '#111827',
  },
  content: {
    flex: 1,
  },
  title: {
    margin: '0 0 8px 0',
    fontSize: '16px',
    fontWeight: '600',
    color: '#111827',
  },
  description: {
    margin: '0 0 12px 0',
    fontSize: '14px',
    color: '#6b7280',
    lineHeight: '1.5',
  },
  meta: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  author: {
    fontSize: '13px',
    color: '#9ca3af',
    fontWeight: '500',
  },
  date: {
    fontSize: '13px',
    color: '#9ca3af',
  },
  deleteBtn: {
    padding: '4px 10px',
    borderRadius: '6px',
    border: '1px solid #fca5a5',
    background: '#fff',
    color: '#ef4444',
    fontSize: '12px',
    cursor: 'pointer',
  },
  error: {
    margin: '8px 0 0 0',
    fontSize: '13px',
    color: '#ef4444',
  },
};